import React, { useEffect, Component } from 'react';
import { Snowflakes } from './components/Snowflakes';
import { ChristmasTrees } from './components/ChristmasTrees';
import { BackgroundMusic } from './components/BackgroundMusic';
export function App() {
  const handleFacebookShare = () => {
    const url = encodeURIComponent(window.location.href);
    const facebookShareUrl = `https://www.facebook.com/sharer/sharer.php?u=${url}`;
    window.open(facebookShareUrl, '_blank', 'width=600,height=400');
  };
  return <div className="min-h-screen bg-gradient-to-b from-blue-900 via-blue-800 to-blue-900 relative overflow-hidden" data-id="element-0">
      <Snowflakes data-id="element-1" />
      <ChristmasTrees data-id="element-2" />
      <BackgroundMusic data-id="element-3" />

      <div className="relative z-10 flex flex-col items-center justify-center min-h-screen px-4 pt-12" data-id="element-4">
        <div className="text-center space-y-8 max-w-2xl" data-id="element-5">
          <h1 className="font-bangers text-5xl md:text-7xl mb-8 tracking-wider text-white drop-shadow-[0_2px_4px_rgba(220,38,38,0.8)]" data-id="element-6">
            May Nakulong na ba?
          </h1>
          <div className="font-bangers text-[8rem] md:text-[16rem] leading-none mb-8 text-white drop-shadow-[0_4px_15px_rgba(255,255,255,0.8)]" data-id="element-7">
            <span className="relative inline-block transform transition-all hover:scale-105 duration-300 animate-fast-pulse" data-id="element-8">
              Wala pa!
            </span>
          </div>
          <p className="font-bangers text-4xl md:text-6xl leading-tight mb-12 text-[#dc2626] drop-shadow-[0_2px_0px_rgba(255,255,255,1)]" data-id="element-9">
            So, kelan?
          </p>
          <div className="mt-12 space-y-8" data-id="element-10">
            <p className="font-bangers text-2xl md:text-4xl leading-relaxed text-[#fbbf24] drop-shadow-[0_1px_2px_rgba(0,0,0,0.8)]" data-id="element-11">
              Join{' '}
              <a href="https://bettergov.ph" className="underline hover:text-white transition-colors duration-300 decoration-2 underline-offset-4" data-id="element-12">
                Bettergov.ph
              </a>{' '}
              to make a change
            </p>
            <div className="flex flex-col md:flex-row gap-6 justify-center items-center mt-6" data-id="element-13">
              <a href="https://bit.ly/bettergovph" className="inline-flex gap-4 items-center justify-center p-3 rounded-2xl transition-transform duration-300 hover:scale-110 shadow-lg h-24 bg-[#5865F2] hover:bg-[#4752C4] border-2 border-white/20 backdrop-blur-sm" aria-label="Join our Discord" data-id="element-14">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/jWTCPoER4obAE6Yokwgyjm/Discord-Symbol-White.svg" alt="Discord" width="64" height="64" className="" data-id="element-15" />
                <div className="text-white font-bangers text-xl" data-id="element-16">
                  discord.gg/bettergovph
                </div>
              </a>
              <button onClick={handleFacebookShare} className="inline-flex gap-4 items-center justify-center p-3 rounded-2xl transition-transform duration-300 hover:scale-110 shadow-lg bg-[#1877F2] hover:bg-[#166fe5] border-2 border-white/20 backdrop-blur-sm h-24" aria-label="Share on Facebook" data-id="element-17">
                <svg width="64" height="64" viewBox="0 0 24 24" fill="white" xmlns="http://www.w3.org/2000/svg" data-id="element-18">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" data-id="element-19" />
                </svg>
                <div className="text-white font-bangers text-xl" data-id="element-20">
                  Share on Facebook
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>;
}